import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// Service global pour toutes les données du dashboard sessions
export const getSessionDashboardData = async () => {
  try {
    const token = JSON.parse(localStorage.getItem('pocketbase_auth'))?.token;
    
    if (!token) {
      throw new Error('Token d\'authentification manquant');
    }

    // Appels parallèles pour récupérer toutes les données du dashboard sessions
    const [overviewResponse, evolutionResponse] = await Promise.all([
      axios.get(`${API_BASE_URL}/api/sessions/overview`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}`
        }
      }),
      axios.get(`${API_BASE_URL}/api/sessions/evolution`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}`
        }
      })
    ]);

    return {
      overview: overviewResponse.data,
      evolution: evolutionResponse.data,
    };
  } catch (error) {
    console.error("Error fetching session dashboard data:", error);
    throw error;
  }
};

// Fonction spécifique pour les données d'overview des sessions
export const getSessionOverviewData = async () => {
  try {
    const token = JSON.parse(localStorage.getItem('pocketbase_auth'))?.token;
    
    const response = await axios.get(`${API_BASE_URL}/api/sessions/overview`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error("Error fetching session overview data:", error);
    throw error;
  }
};

// Fonction spécifique pour les données d'évolution des sessions
export const getSessionEvolutionData = async () => {
  try {
    const token = JSON.parse(localStorage.getItem('pocketbase_auth'))?.token;
    
    const response = await axios.get(`${API_BASE_URL}/api/sessions/evolution`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error("Error fetching session evolution data:", error);
    throw error;
  }
};

// Fonction spécifique pour les statistiques d'attendance
export const getAttendanceStats = async () => {
  try {
    const token = JSON.parse(localStorage.getItem('pocketbase_auth'))?.token;
    console.log('🔍 [Frontend] Récupération des stats d\'attendance...');
    
    const response = await axios.get(`${API_BASE_URL}/api/sessions/attendance-stats`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}`
      }
    });
    
    console.log('✅ [Frontend] Stats d\'attendance reçues:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ [Frontend] Erreur lors de la récupération des stats d'attendance:", error);
    throw error;
  }
};

// Alias pour compatibilité avec le composant EvolutionProspect
export const getEvolutionData = getSessionEvolutionData;
